package org.moxultimate.topwithmox.productcrud.di

import org.koin.dsl.module
import org.moxultimate.topwithmox.productcrud.api.ProductCRUDRepository
import org.moxultimate.topwithmox.productcrud.main.ProductCRUDViewModel

/**
 * ProductCRUDModule
 * Koin module for the product content CRUD feature.
 * Reuses HttpClient and ProductRepository singletons registered in productModule.
 * Registers ProductCRUDRepository and injects both repositories into the ViewModel factory.
 */
val productCRUDModule = module {

    single {
        ProductCRUDRepository(httpClient = get())
    }

    factory {
        ProductCRUDViewModel(repository = get(), crudRepository = get())
    }
}
